import { useTranslation } from '../../i18n/useTranslation';
import styles from './NotSearchResultsPage.module.scss';

const NotSearchResultsPage: React.FC = () => {
    const { t } = useTranslation('translation');
    return (
        <>
            <div className={styles.container}>
                <div className={styles.row}>
                    <label className={styles.h1}>{t('PRODUCT_NOT_FOUND')}</label>
                </div>
            </div>
        </>
    );
};

export default NotSearchResultsPage;
